import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./accessRestrictedModal.css";
import { useSelector } from "react-redux";
const contactNumber = process.env.REACT_APP_CONTACT_NUMBER;

const normalizePhoneForWa = (num = "") => num.replace(/[^\d]/g, "");

const buildWaLink = (phone, text) => {
  const waPhone = normalizePhoneForWa(phone);
  const encoded = encodeURIComponent(text);
  return `https://wa.me/${waPhone}?text=${encoded}`;
};

const AccessRestrictedModal = ({
  show,
  onHide,
  returnPath,
  fallbackPath,
  accent = "#a52222ff",
  accent2 = "#7c1616ff",
  title = "Contenido disponible contratando SIGER",
  subtitle = "Para acceder a este módulo necesitás activar tu suscripción.",
}) => {
  const navigate = useNavigate();
  const userCompany = useSelector((state) => state.user.currentUser?.name_company);
  const userName = useSelector((state) => state.user.currentUser?.name);
  const accessTo = useSelector((state) => state.user.currentUser?.access_to);


  const handleClose = () => {
    onHide();

    if (accessTo === "DEMO") {
      navigate("/health-safety", { replace: true });
      return;
    }

    const destination = returnPath || fallbackPath;

    if (destination) {
      navigate(destination, { replace: true });
      return;
    }

    navigate(-1);
  };

  const message =
    " Hola, me contacto desde {empresa}, me interesa contratar los módulos de Siger...";

  const messageMail = `Hola soy ${userName}, me contacto de la empresa ${userCompany} para contratar los módulos del sistema SIGER`

  const defaultMessage = message.replace("{empresa}", userCompany || "no funciono");
  const waHref = buildWaLink(contactNumber, defaultMessage);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="access-restricted-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <div
          className="ar-wrapper ar-wrapper-light"
          style={{ ["--ar-accent"]: accent, ["--ar-accent-2"]: accent2 }}
        >
          <div className="ar-card ar-card-light">
            <div className="ar-badge ar-badge-light">
              <span className="ar-icon" aria-hidden>
                🔒
              </span>
              <span>Acceso restringido</span>
            </div>

            <h1 className="ar-title ar-title-light">{title}</h1>
            <p className="ar-text ar-text-light">{subtitle}</p>
            <p className="ar-text ar-text-light">
              Si querés ver esta página, contactanos vía email o por WhatsApp
            </p>
            <div className="ar-features">
              <div className="ar-feature-group">
                <h3 className="ar-feature-title">Operación y análisis</h3>
                <ul className="ar-list">
                  <li>
                    <strong>Dashboards interactivos</strong> personalizables
                  </li>
                  <li>
                    <strong>Módulo de informes </strong> y análisis con IA
                  </li>
                  <li>
                    <strong>Eventos y alertas</strong>: creador de alertas en
                    tiempo real con condiciones, notificaciones instantáneas y
                    registro histórico.
                  </li>
                </ul>
              </div>

              <div className="ar-feature-group">
                <h3 className="ar-feature-title">Administración</h3>
                <ul className="ar-list">
                  <li>
                    <strong>
                      Listado de usuarios, sucursales y proveedores
                    </strong>
                  </li>
                  <li>
                    <strong>Módulo de consumos y costos</strong>: control y
                    carga de facturas, reportes anuales y mensuales.
                  </li>
                  <li>
                    <strong>Soporte prioritario</strong> con tiempos de
                    respuesta acelerados
                  </li>
                </ul>
              </div>
            </div>

            <div className="ar-actions">
              <a
                className="ar-btn ar-btn-primary"
                href={waHref}
                target="_blank"
                rel="noreferrer"
              >
                Hablar por WhatsApp
              </a>

              <a
                className="ar-btn ar-btn-outline"
                 href= {`mailto:contacto@gruponabla.com.ar?subject=Consulta%20contratación%20SIGER&body=${encodeURIComponent(messageMail)}`}
              >
                Email: {"contacto@gruponabla.com.ar"}
              </a>

              <button className="ar-btn ar-btn-ghost" onClick={handleClose}>
                VOLVER
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AccessRestrictedModal;
